import { useWorkspaces } from "@/hooks/useWorkspaces";
import { PromptService } from "@/services/prompt/prompt.service";
import { showError, showSuccess } from "@/utils/notification";

export const usePrompts = () => {
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { data, error, isLoading, mutate } = PromptService.getPrompts(sessionCurrentWorkspaceId);

  const getPrompt = (id: string | undefined) => data?.find((prompt) => prompt.id === id);

  const updatePrompt = async (id: string, content: string) => {
    try {
      await PromptService.update(id, content);
      showSuccess("プロンプトを更新しました。");
    } catch (error) {
      showError("プロンプトの更新に失敗しました。");
      console.error("Error updating prompt:", error);
    }
  };

  return {
    prompts: data,
    error,
    isLoading,
    mutate,
    getPrompt,
    updatePrompt,
  };
};
